<template>
        <!---- Start Preview ---->
            <div class="row justify-content-center border pa-1">
              <table width="95%" style="border:1px solid #b3d4fc;">
                <tr>
                  <td colspan="3">
                      <div class="header-content ">
                        <div class="col-12 pa-0">
                            <img width="100%" class="" :src="headersection" >
                        </div>
                      </div>  
                    </td>  
                </tr>
                <tr>
                  <td  style="vertical-align:top;" width="30%">
                   <div class="col-lg-12 col-md-12 pa-0 left-content">
                     <img class="leftsection" width="100%" height="60%" :src="leftsection" >
                   </div>
                  </td>
                   <td colspan="2" width="70%" :style="{ 'vertical-align':'top', 'background-image': 'url(' + rightsection + ')','background-size':'100% 98%' }">
                            <div class="col-lg-12 col-md-12 pa-0 draggablecontent" :style="{ 'background-image': 'url(' + adhere + ')' }"  >
                                  <div class="bannercontenthtml bannercontentimage" v-html="bannercontent">
                                  </div>
                    </div> 
                    </td>  
                </tr>  
            </table>   
            </div>
           
      <!---- End Preview ---->
  </template>
 <script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  export default {
    name: 'Pi3cktemplate',
    props:[
       'bannercontent',
    ],
    data: () => ({
      headersection : require("@/assets/pi3ckheadersection.png"),
      leftsection : require("@/assets/pi3ckleftsection.png"),
    //  middlesection:  require("@/assets/middlesection.png"),
      rightsection :  require("@/assets/pi3ckrightsection.png"),
      adhere: require("@/assets/506.jpg"),
     }),
      mounted() {
     },
   computed:{
     baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            }
     },
    methods: { 
    }
  }
</script>
<style scoped>
.row {
  margin-left: 0px;
}
.headersection{height:32px;}
.padding-top-0{padding-top: 0px !important;}
.padding-right-0{padding-right: 0px !important;}
.padding-bottom-0{padding-bottom: 0px !important;}    
.draggable-list {
  color: #fff;
  border: 1px solid;
  height: 100px;
}
.header-content{width:100%;height: 24px;}
.left-content{padding-top:0px;padding-right:0px; }
.center-content{height: 100%;}
.right-content{height: 100%;}
.footer-content{height: 100%; border:1px solid #b3d4fc;}
.draggablecontent{background-size: 100% 100%;margin-top: 20%;width: 50%;margin-left: 25%;}
.bannercontentimage{width:100%;height:100%;position: relative;}
.bannercontenthtml{width:100%;height:100%;position: relative;color:#000; background-color: #fff;}
.postionsection{width: 100%;height: 100px;}
.leftsection{height:370px;}
</style>